import { Card, CardContent, Grid, Icon, Typography } from '@material-ui/core';
import { useKeycloak } from '@react-keycloak/web';
import { link } from 'app/utils/coresUtil';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { confirmarSenhaStyles } from './styles/Styles';

const ConfirmarEmail = () => {
  const { keycloak } = useKeycloak();
  const styles = confirmarSenhaStyles();
  const location = useLocation();

  return (
    <div className={styles.container}>
      <Card className={styles.card}>
        <CardContent className={styles.cardContent}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <div className={styles['div.icone']}>
                <Icon className={styles.icone} color="action">
                  email
                </Icon>
              </div>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h5" className={styles.subtituloConfirmarEmail}>
                Confirme seu endereço de e-mail
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: 'center', marginBottom: '1.6rem', width: '100%' }}>
                O e-mail de confirmação está sendo enviado para <b>{location.state?.email}</b>.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: 'center', width: '100%' }}>
                Verifique sua caixa de entrada e clique no comando "Redefinir senha" para confirmar seu endereço de
                e-mail e atualizar sua senha
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <div className={styles.linkVoltar}>
                <Link to="/" style={{ color: link }} onClick={() => keycloak.login()}>
                  Voltar para login
                </Link>
              </div>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
};

export default ConfirmarEmail;
